var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "nounderline",
        attrs: {
          "aria-expanded": "false",
          "aria-haspopup": "true",
          "data-target": `#${_vm.id}`,
          "data-toggle": "dropdown",
          href: "#",
          role: "button"
        },
        on: {
          click: function($event) {
            return _vm.$emit("click", $event)
          }
        }
      },
      [_c("div", [_vm._t("default")], 2)]
    ),
    _c(
      "div",
      {
        staticClass: "dropdown-menu",
        class: { show: _vm.show },
        attrs: { id: _vm.id }
      },
      [_vm._t("drop")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }